import React, { Component } from 'react'

import { getHighestLevel } from '@global/helpers/helpers'

import CounterRow from '../CounterRow'
import Table from './components/Table'

import './styles.scss'

export default class WonTenders extends Component {
    render() {
        const { summary, module, block, customData, id, level, locale } = this.props

        const parsedLevel = getHighestLevel(level)

        return (
            <div className={'won-tenders-wrapper'}>
                <CounterRow summary={summary} selector={'won'} />
                {parsedLevel > 20 && (
                    <div className={'table-wrapper'}>
                        <Table
                            block={block}
                            module={module}
                            customData={customData}
                            id={id}
                            level={level}
                            locale={locale}
                        />
                    </div>
                )}
            </div>
        )
    }
}
